// extracted by mini-css-extract-plugin
module.exports = {"icon":"_aeac7a1","textWrapper":"_67de896"};